import { Button } from '@progress/kendo-react-buttons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { TextBox } from '@progress/kendo-react-inputs';
import React from 'react';
import { useAppDispatch } from '../../hooks/store-hooks';
import { startRecording } from '../../state/reducers/recording';
import { RecordingStartFailErrors } from '../../../services/actor-messages';
import { NavLink } from 'react-router';
import { RecordingStartFailText } from '../../../components/weather/settings/settings-options';

export function StartRecording(props: { onClose?: () => void }) {
    const [busy, setBusy] = React.useState(false);
    const [name, setName] = React.useState<string>('');
    const [error, setError] = React.useState<RecordingStartFailErrors | null>(null);
    const dispatch = useAppDispatch();

    return (
        <Dialog title="Record" onClose={props.onClose} width={'min(100vw, 300px)'}>
            <div className="secondary-text">Recording file name:</div>
            <TextBox placeholder="File name" value={name} onChange={(e) => setName(e.value as string)} />
            {error !== null && <div className="text-danger pt-2">{RecordingStartFailText[error]}</div>}
            {error === RecordingStartFailErrors.noDir && (
                <span className="text-danger pt-2">
                    Go to <NavLink to="/settings?search=Record+folder">settings</NavLink> to set it up.
                </span>
            )}
            <DialogActionsBar>
                <Button
                    disabled={!name || busy}
                    themeColor={'primary'}
                    onClick={() => {
                        setBusy(true);
                        dispatch(startRecording({ recordingName: name }))
                            .unwrap()
                            .then(() => {
                                setError(null);
                                props.onClose?.();
                            })
                            .catch((reason) => {
                                setError(reason);
                            })
                            .finally(() => {
                                setBusy(false);
                            });
                    }}>
                    Start
                </Button>
                <Button onClick={props.onClose}>Cancel</Button>
            </DialogActionsBar>
        </Dialog>
    );
}
